import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { MergeType as MergeIcon } from '@mui/icons-material';

const MergeButton = ({
  onClick,
  loading = false,
  label = 'Merge PDF',
  disabled = false,
  variant = 'outlined',
  size = 'small',
  fullWidth = false,
  color = 'primary',
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      color={color}
      onClick={onClick}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      startIcon={
        loading ? <CircularProgress size={16} color="inherit" /> : <MergeIcon />
      }
    >
      {loading ? 'Merging...' : label}
    </Button>
  );
};

export default MergeButton;
